import { combineReducers } from "redux";
import CommonReducer from "./CommonReducer";
import popup from "./popup";
import SystemSettingsReducer from "./SystemSettings";
import workItems from "./workItemsReducer";

const reducers = combineReducers({CommonReducer, popup, SystemSettingsReducer, workItems});
export default reducers;